/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import axios from 'axios';

export function getBaseURL() {
  const isEndingWithFr = window.location.href.includes('.fr');
  return isEndingWithFr
    ? process.env.BASE_URL_INT_FR
    : process.env.BASE_URL_INT;
}

const client = axios.create({
  baseURL: getBaseURL(),
  json: true,
});

client.interceptors.request.use(
  async (config) => {
    const conf = config;
    conf.headers.Authorization = await Vue.prototype.$auth.getIdToken();
    return conf;
  },
  (error) => Promise.reject(error)
);

const sleepRequest = (milliseconds, originalRequest) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(client(originalRequest)), milliseconds);
  });
};

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { config, response } = error;
    if (
      (!response || response.status >= 500) &&
      config &&
      config.__retry &&
      config.__retry.nbLeft > 0
    ) {
      config.__retry.nbLeft -= 1;
      const originalRequest = config;
      // eslint-disable-next-line no-console
      console.log(
        `Retrying request ${config.url} received with status code : ${
          response ? response.status : ''
        }.`
      );
      return sleepRequest(config.__retry.timeout, originalRequest);
    }
    return Promise.reject(error);
  }
);

// client.defaults.paramsSerializer = (params) => {
//   return buildUrl('', params)
//     .replace('[', '%5B')
//     .replace(']', '%5D');
// };

function encode(val) {
  return encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+');
}

client.defaults.paramsSerializer = (params) => {
  const parts = [];

  Object.entries(params).forEach(([key, val]) => {
    if (val === null || typeof val === 'undefined') {
      return;
    }

    if (Array.isArray(val)) {
      key += '[]';
    } else {
      val = [val];
    }

    val.forEach((v) => {
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
        v = JSON.stringify(v);
      }
      parts.push(`${encode(key)}=${encode(v)}`);
    });
  });

  return parts.join('&');
};

export default client;
